var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{staticClass:"batch-status",class:[_vm.statusClass(_vm.status), _vm.size === 'md' ? 'batch-status-md' : '']},[_c('fa-icon',{attrs:{"icon":['fal', _vm.getIcon(_vm.status)]}}),_vm._v(_vm._s(_vm.getName(_vm.status))+" ")],1)
}
var staticRenderFns = []

export { render, staticRenderFns }